import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const Sidebar = (props) => {
    const {t} = useTranslation();
    return (
        
        <div className="InrPgLyOtSdr">
            <ul className="SdBarLst">
                <li>
                    <Link to='/dashboard'>
                        <img src={require('../../assets/images/grid.png')} alt="" className="mr-2" />
                        <span>{t('Dashboard')}</span>
                    </Link>
                </li>
                <li>
                    <Link to='/buytoken'>
                        <img src={require('../../assets/images/coin.png')} alt="" className="mr-2" />
                        <span>{t('Buy Token')}</span>
                    </Link>
                </li>
                <li>
                    <Link to='/transaction'>
                        <img src={require('../../assets/images/exchange.png')} alt="" className="mr-2" />
                        <span>{t('Transactions')}</span>
                    </Link>
                </li>
                <li>
                    <Link to='/mytoken'>
                        <img src={require('../../assets/images/wallet-money.svg').default} alt="" className="mr-2" />
                        <span>{t('My Token')}</span>
                    </Link>
                </li>
                <li>
                    <Link to='/withdraw'>
                        <img src={require('../../assets/images/money-recive.png')} alt="" className="mr-2" />
                        <span>{t('Withdraw')}</span>
                    </Link>
                </li>
                <li>
                    <Link to='/howtobuy'>
                        <img src={require('../../assets/images/card-tick.png')} alt="" className="mr-2" />
                        <span>{t('How to Buy')}</span>
                    </Link>
                </li>
                <li>
                    <Link to='/myprofile'>
                        <img src={require('../../assets/images/profile-circle.png')} alt="" className="mr-2" />
                        <span>{t('Profile')}</span>
                    </Link>
                </li>
            </ul>
        </div>
        
    );
   
}

export default Sidebar;